module.exports = __webpack_public_path__ + "98ae6e9cc3471cdfde78c174eee2e296.MP3";